import styled from 'styled-components'

import { DataListWithReduxPagination } from 'shared/ui/DataList'

export const StyledDataList = styled(DataListWithReduxPagination)`
  overflow-y: auto;
`
